module.exports = __webpack_public_path__ + "static/media/completed.5581ac90.svg";